import { Button, Modal } from 'antd';

import owlImg from '../../../../assets/img/pet/corujaFeliz.png';

import { ContainerFooter, Content, ModalContainer } from './styles';

interface RequestProps {
  id: number;
  user: {
    name: string;
    foto: string;
  };
}

interface SuccessAcceptUserModalProps {
  isOpen: boolean;
  request: RequestProps;
  closeModal: () => void;
}

export const SuccessAcceptUserModal = ({
  closeModal,
  isOpen,
  request,
}: SuccessAcceptUserModalProps) => {
  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <ContainerFooter key="footer">
            <Button type="primary" onClick={closeModal} key="closeModal">
              Fechar
            </Button>
          </ContainerFooter>,
        ]}
      >
        <Content>
          <h1>Sucesso!</h1>

          <img src={owlImg} alt="Imagem de uma coruja" />

          <span>
            <p>
              <strong>
                {request.user ? `${request.user.name} ` : 'Jogador(a) '}
              </strong>
              entrou para sua liga.
            </p>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
